import React from "react"

interface ITimelineProps<T>{
    itemList: Array<T>,
    children: (item: T) => React.ReactNode,
    keyGetter: (item: T) => string,
    noDataIndication: string
}

export default function Timeline<T>(props: ITimelineProps<T>) {
    return (
        <div className="timeline timeline-3">
            <div className="timeline-items">
                {
                    props.itemList.length ? (
                        props.itemList.map(item => <React.Fragment key={props.keyGetter(item)}>{props.children(item)}</React.Fragment>)
                    ) : (
                        <div className="text-muted text-center">
                            {props.noDataIndication}
                        </div>
                    )
                }
            </div>
        </div>
    )
}